"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Union_1 = require("../Union");
const union_1 = __importDefault(require("../Union/union"));
const _internals_1 = require("../_internals");
const symbols_1 = require("../_internals/symbols");
const ReaderMonad = () => (cases, global) => {
    cases.Reader.prototype.local = function (fn) {
        return (0, symbols_1.getTypeRep)(this).pure((...env) => this.run(fn(...env)));
    };
    global.runReader = function (reader, env) {
        return reader.run(env);
    };
    global.ask = function () {
        return new cases.Reader((x) => x);
    };
};
const Defs = {
    trivials: ["Reader"],
    identities: [],
    pure: "Reader",
    lazy: true,
    resolve: ["Reader"],
    overrides: {
        fmap: {
            Reader(fn) {
                return Reader.Reader((...env) => fn(this.get()(...env)));
            },
        },
        chain: {
            Reader(fn) {
                return Reader.Reader((env) => fn(this.run(env)).run(env));
            },
        },
        join: {
            Reader() {
                return Reader.Reader((env) => this.run(env).run(env));
            }
        },
        apply: {
            Reader(readerFn) {
                return Reader.Reader((env) => readerFn.get()(this.run(env)));
            },
        },
        show: {
            Reader() {
                return "[Reader => R => _]";
            },
        },
        run: {
            Reader(...env) {
                return this.get()(...env);
            },
        },
        toThenable: {
            Reader() {
                return {
                    then: (res, rej) => {
                        try {
                            res(this.run(undefined));
                        }
                        catch (e) {
                            rej(e);
                        }
                    }
                };
            }
        },
        toPromise: {
            Reader(args) {
                return Promise.resolve(this.run(args));
            }
        }
    },
};
const Reader = (0, union_1.default)("Reader", {
    Reader: (fn) => (env) => (0, _internals_1.extractWith)([env])(fn),
}, [
    (0, Union_1.Runnable)(Defs),
    (0, Union_1.Functor)(Defs),
    (0, Union_1.Applicative)(Defs),
    (0, Union_1.Monad)(Defs),
    (0, Union_1.Show)(Defs),
    (0, Union_1.Thenable)(Defs),
    ReaderMonad()
]).constructors({
    of(x) {
        return this.Reader(x);
    },
    from(x) {
        return this.Reader(x);
    },
});
exports.default = Reader;
